import React from "react";

function LevelIcon({ color = "#ffff" }: IconPropsType) {
  return (
    <svg
      id="level"
      xmlns="http://www.w3.org/2000/svg"
      className="w-[17.56px] lg:w-[1.375rem]"
      width="40"
      height="30"
      viewBox="0 0 40 30"
    >
      <rect
        id="FILL"
        width="14"
        height="30"
        transform="translate(26)"
        fill={color}
      />
      <path
        id="STRTOKE"
        d="M1.5,1.5v27h11V1.5H1.5M0,0H14V30H0Z"
        transform="translate(26)"
        fill="#220859"
      />
      <rect
        id="FILL-2"
        data-name="FILL"
        width="14"
        height="20"
        transform="translate(13 10)"
        fill={color}
      />
      <path
        id="STRTOKE-2"
        data-name="STRTOKE"
        d="M1.5,1.5v17h11V1.5H1.5M0,0H14V20H0Z"
        transform="translate(13 10)"
        fill="#220859"
      />
      <rect
        id="FILL-3"
        data-name="FILL"
        width="14"
        height="10"
        transform="translate(0 20)"
        fill={color}
      />
      <path
        id="STRTOKE-3"
        data-name="STRTOKE"
        d="M1.5,1.5v7h11v-7H1.5M0,0H14V10H0Z"
        transform="translate(0 20)"
        fill="#220859"
      />
    </svg>
  );
}

export default LevelIcon;
type IconPropsType = {
  color?: string;
};
